declare global {
  interface Window {
    ScrollSmoother?: ScrollSmootherStatic;
  }
}

interface ScrollSmootherInstance {
  scrollTo: (
    target: Element | string,
    smooth?: boolean,
    position?: string
  ) => void;
}

interface ScrollSmootherStatic {
  get: () => ScrollSmootherInstance | undefined;
}

/**
 * Smoothly scrolls to an element using ScrollSmoother
 * @param elementId - The ID of the element to scroll to
 * @param offset - The offset from the top of the element (default: 0px)
 */
export const smoothScrollToElement = (
  elementId: string,
  offset: number = 0
) => {
  const element = document.getElementById(elementId);
  if (!element) return;

  const smoother = window.ScrollSmoother?.get?.();
  if (smoother) {
    setTimeout(() => {
      smoother.scrollTo(element, true, `top ${offset}px`);
    }, 50); // slight delay to ensure smoother is ready
    return;
  }

  // Fallback to native smooth scroll when ScrollSmoother isn't available
  try {
    element.scrollIntoView({ behavior: "smooth", block: "start" });
    // Apply additional offset if requested (native scrollIntoView doesn't have offset)
    if (offset !== 0) {
      window.setTimeout(() => {
        window.scrollBy({ top: offset, behavior: "smooth" });
      }, 100);
    }
  } catch {
    // Fallback for older browsers
    const top = element.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo(0, top);
  }
};
